(function () {
    'use strict';

    angular.module('app.blogPost', ['smart-table', 'treeControl', 'ui.bootstrap', 'ngTable']);
})();